if (!customElements.get('fragrance-card-selector')) {
  class FragranceCardSelector extends HTMLElement {
    constructor() {
      super();

      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleDocumentPointerDown = this.handleDocumentPointerDown.bind(this);
      this.handleToggle = this.handleToggle.bind(this);
    }

    connectedCallback() {
      if (this.isConnectedToEvents) return;

      this.details = this.querySelector('details');
      this.isConnectedToEvents = true;

      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      document.addEventListener('pointerdown', this.handleDocumentPointerDown);

      if (this.details) {
        this.details.addEventListener('toggle', this.handleToggle);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
      document.removeEventListener('pointerdown', this.handleDocumentPointerDown);

      if (this.details) {
        this.details.removeEventListener('toggle', this.handleToggle);
      }

      this.isConnectedToEvents = false;
    }

    handleClick(event) {
      const option = event.target.closest('[data-variant-option]');

      if (!option || option.disabled || !this.contains(option)) return;

      event.preventDefault();
      this.selectVariant(option);
    }

    handleKeydown(event) {
      if (event.key !== 'Escape' || !this.details?.open) return;

      event.preventDefault();
      this.details.open = false;
      this.details.querySelector('summary')?.focus();
    }

    handleDocumentPointerDown(event) {
      if (!this.details?.open || this.contains(event.target)) return;

      this.details.open = false;
    }

    handleToggle() {
      if (!this.details?.open) return;

      document
        .querySelectorAll('fragrance-card-selector details[open]')
        .forEach((details) => {
          if (details !== this.details) details.open = false;
        });
    }

    selectVariant(option) {
      const {
        variantId,
        variantUrl,
        size,
        price,
        compareAtPrice = '',
        unitPrice = '',
      } = option.dataset;

      if (!variantId || !variantUrl) return;

      this.dataset.selectedVariantId = variantId;

      const selectedSize = this.querySelector('[data-selected-size]');
      const selectedPrice = this.querySelector('[data-selected-price]');
      const selectedComparePrice = this.querySelector(
        '[data-selected-compare-price]',
      );
      const selectedUnitPrice = this.querySelector('[data-selected-unit-price]');

      if (selectedSize) selectedSize.textContent = size || '';
      if (selectedPrice) selectedPrice.textContent = price || '';

      if (selectedComparePrice) {
        selectedComparePrice.textContent = compareAtPrice;
        selectedComparePrice.hidden = !compareAtPrice;
      }

      if (selectedUnitPrice) {
        selectedUnitPrice.textContent = unitPrice;
        selectedUnitPrice.hidden = !unitPrice;
      }

      this.querySelectorAll('[data-variant-option]').forEach((item) => {
        const isSelected = item === option;

        item.classList.toggle('is-selected', isSelected);
        item.setAttribute('aria-selected', String(isSelected));

        const check = item.querySelector('[data-selected-check]');
        if (check) check.hidden = !isSelected;
      });

      const card = this.closest('product-card');

      if (card) {
        card.querySelectorAll('[data-fragrance-card-link]').forEach((link) => {
          link.href = variantUrl;
        });

        card.querySelectorAll('quick-buy-modal').forEach((modal) => {
          modal.setAttribute('product-url', variantUrl);
        });

        card
          .querySelectorAll('form[action*="/cart/add"] input[name="id"]')
          .forEach((input) => {
            input.value = variantId;
          });
      }

      if (this.details) this.details.open = false;

      this.dispatchEvent(
        new CustomEvent('fragrance-card:variant-change', {
          bubbles: true,
          detail: {
            variantId,
            variantUrl,
            size,
          },
        }),
      );
    }
  }

  customElements.define('fragrance-card-selector', FragranceCardSelector);
}
